import { gql } from '__generated__';

export default gql(`
  mutation ToggleMailPermission($input: ToggleMailPermissionInput!) {
    toggleMailPermission(input: $input) {
      id
      events {
        id
      }
    }
  }
`);
